export default {
    principal: {
        id: 1,
        description: 'Principal'
    },
    work: {
        id: 2,
        description: 'Trabajo'
    },
    personal: {
        id: 3,
        description: 'Personal'
    },
    backoffice: {
        id: 4,
        description: 'Backoffice'
    }
};
